import PhotoIcon from '@mui/icons-material/Photo';
import { Box, ButtonBase, Typography } from '@mui/material';
import { Center, FlexRow } from '@ocodelib/mui';
import { INK_BOOK_IMG_ASPECT } from '@repo-foundation/ink-constants';
import { toThumbnailUrl } from '@repo-foundation/util/image-url-util';
import clsx from 'clsx';
import React from 'react';
import type { LocalBookItem } from '../types';

interface Props {
  item: LocalBookItem;
  seq: number;
  sectionSeq?: number;
  className?: string;
  onClickRow?: React.MouseEventHandler;
}

const THUMB_HEIGHT = 80;
const THUMB_WIDTH = THUMB_HEIGHT * (INK_BOOK_IMG_ASPECT.w / INK_BOOK_IMG_ASPECT.h);

export function BookListRow(props: Props) {
  const { item, seq, sectionSeq, onClickRow, className } = props;
  const { title, book } = item;

  const thumbnailUrl = book.thumbnailUrl ? toThumbnailUrl(book.thumbnailUrl) : book.thumbnailUrl;

  return (
    <ButtonBase
      component="div"
      className={clsx('BookListRow-root', className)}
      onClick={onClickRow}
      sx={{
        position: 'relative',
        bgcolor: '#fff',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        boxShadow: 1,
        borderRadius: '5px',
        overflow: 'hidden',
        '&:hover': {
          boxShadow: 3,
          // '&::before': {
          //   position: 'absolute',
          //   top: 0,
          //   left: 0,
          //   right: 0,
          //   bottom: 0,
          //   content: '""',
          //   border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          // },
        },
      }}
    >
      <Center
        className="DtbItemBookRow-imgWrap"
        sx={{
          lineHeight: 1,
          width: THUMB_WIDTH,
          height: THUMB_HEIGHT,
          overflow: 'hidden',
          color: '#bbb',
          bgcolor: '#f5f5f5',
        }}
      >
        {thumbnailUrl && (
          // eslint-disable-next-line @next/next/no-img-element
          <img src={thumbnailUrl} width={THUMB_WIDTH} height={THUMB_HEIGHT} alt="thumbnail" />
        )}

        {!thumbnailUrl && <PhotoIcon sx={{ fontSize: '30px' }} />}
      </Center>
      <FlexRow
        sx={{
          flex: 1,
          alignItems: 'baseline',
          py: 2,
          mx: 2,
          overflow: 'hidden',
        }}
      >
        <Typography>
          {sectionSeq}.{seq}
        </Typography>
        <Box
          sx={{
            ml: 2,
            flex: 1,
            overflow: 'hidden',
          }}
        >
          <Typography variant="subtitle1">{title}</Typography>
          {book.introContent && (
            <Typography
              variant="body2"
              sx={{
                width: '100%',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                color: '#666',
                mt: 0.5,
              }}
            >
              {book.introContent}
            </Typography>
          )}
        </Box>
      </FlexRow>
    </ButtonBase>
  );
}
